import React, { useEffect, useRef, useState } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { Overlay, Tooltip } from "react-bootstrap";

import importAll from "../components/chat-component/images";
import PersonaFooter from "../components/chat-component/PersonaFooter";
import FilterFooter from "../components/chat-component/FilterFooter";
import ToneFooter from "../components/chat-component/ToneFooter";
import { useSelector } from "react-redux";

const images = importAll(
  require.context(
    "../assets/images/",
    false,
    /\.(png|jpe?g|svg|GIF|webp|json)$/
  )
);

export default function ChatPageFooter({
  setBasePrompt,
  handleFaqSend,
  setInputtedQuestion,
  inputedQuestion,
  loading,
  scrollToBottom,
  setReferenceDocument,
  payloadData,
  setSelectedTone,
  basePrompt,
  selectedTone,
  UpdateData,
  selectedConversation,
}) {
  const [keyPressed, setKeyPressed] = useState(false);
  const [countOfInput, setCountOfInput] = useState(0);
  const [recordStart, setRecordStart] = useState(false);
  const [message, messageSet] = useState("");
  const [browserSupport, setBrowserSupport] = useState(true);
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const { siteData } = useSelector((state) => state.getSiteData);
  useEffect(() => {
    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
      setBrowserSupport(false);
      // return null;
    }
  }, []);

  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening,
  } = useSpeechRecognition({
    commands: [
      {
        command: "reset",
        callback: () => resetTranscript(),
      },
      {
        command: "shut up",
        callback: () => messageSet("I wasn't talking."),
      },
      {
        command: "Hello",
        callback: () => messageSet("Hi there!"),
      },
    ],
  });

  useEffect(() => {
    if (finalTranscript !== "") {
      setInputtedQuestion(finalTranscript);
      SpeechRecognition.stopListening();
      handleFaqSend();
      setCountOfInput(0);
      resetTranscript();
      setRecordStart(false);
    }
  }, [interimTranscript, finalTranscript]);

  const listenContinuously = () => {
    if (browserSupport) {
      SpeechRecognition.startListening({
        continuous: true,
        language: "en",
      });
      setRecordStart(true);
    } else {
      setShow(true);
    }
  };

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false);
      }, 1500);
    }
  }, [show]);

  useEffect(() => {
    setInputtedQuestion(transcript);
    setCountOfInput(inputedQuestion.length);
  }, [transcript]);

  const handleKeyPress = (event) => {
    if (event.keyCode === 13 && inputedQuestion.length > 0) {
      event.preventDefault();
      handleFaqSend(setKeyPressed);
      setCountOfInput(0);
      setInputtedQuestion("");
      scrollToBottom();
    }
    if (event.clipboardData) {
      const pastedText = event.clipboardData.getData("text/plain");
      if (pastedText.length > 3000) {
        event.preventDefault();
        setInputtedQuestion(pastedText.substring(0, 3000));
        setCountOfInput(3000);
      }
    }
  };

  const handleChange = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length > 3000) {
      setInputtedQuestion(inputValue.substring(0, 3000));
      setCountOfInput(3000);
    } else {
      setInputtedQuestion(inputValue);
      setCountOfInput(inputValue.length);
    }
  };

  const onChangeFilter = (filter) => {
    payloadData.filter = [];
    if (filter) payloadData.filter.push(filter);
  }

  return (
    <>
      <div className="chatfooter-heading-option d-flex align-items-center flex-nowrap sm:flex-wrap">
        <PersonaFooter setBasePrompt={setBasePrompt} userId={siteData?.userId} selectedTone={selectedTone} UpdateData={UpdateData} />
        <ToneFooter setSelectedTones={setSelectedTone} userId={siteData?.userId} basePrompt={basePrompt} UpdateData={UpdateData} />
        {/* <PersonaFooter setBasePrompt={setBasePrompt} />
        <ToneFooter setSelectedTone={setSelectedTone} /> */}
        <FilterFooter onChangeFilter={onChangeFilter} />
      </div>
      <div className="chat-form-block">
        <div className="chat-form-control">
          <textarea
            onFocus={() => setReferenceDocument("")}
            className="form-control"
            placeholder="Type here..."
            onKeyDown={handleKeyPress}
            onChange={handleChange}
            value={inputedQuestion}
            disabled={loading.current}
            autoFocus
          ></textarea>
          <span className="chat-form-note">{countOfInput}/3000</span>
          {countOfInput > 0 ? (
            <button
              type="submit"
              className="send-chat btn"
              onClick={() => {
                handleFaqSend();
                scrollToBottom();
              }}
              disabled={loading.current}
            >
              <img src={images["send-chat.svg"]} alt="" />
            </button>
          ) : (
            <>
              <button
                ref={target}
                type="submit"
                className={`send-chat btn ${recordStart ? "blink-btn" : ""}`}
                onClick={() => listenContinuously()}
                disabled={loading.current}
              >
                <img src={images["chat-send-icon.svg"]} alt="" />
              </button>
              <Overlay target={target.current} show={show} placement="top">
                {(props) => (
                  <Tooltip id="overlay-example" {...props}>
                    Your browser does not support! Try Chrome desktop, maybe?
                  </Tooltip>
                )}
              </Overlay>
            </>
          )}
        </div>
      </div>
    </>
  );
}
